import foodImg1 from "../images/food-image-1.png";
import foodImg2 from "../images/food-image-2.png";
import foodImg3 from "../images/food-image-3.png";
import foodImg4 from "../images/food-image-4.png";
import foodImg5 from "../images/food-image-5.png";
import foodImg6 from "../images/food-image-6.png";
import foodImg7 from "../images/food-image-7.jpg";
import foodImg8 from "../images/food-image-8.jpg";
import foodImg9 from "../images/food-image-9.jpg";
import foodImg10 from "../images/food-image-10.jpg";

const foods = [
    {
        id: "01",
        title: "Tomato With Tofu Salad",
        price: 99,
        oldPrice: 9,
        discount: "15%",
        desc: "this is the description",
        reviews: [
           
        ],
        avgRating: 4.5,
        photo: foodImg1,
        featured: true,
    },
    {
        id: "02",
        title: "Tomato With Tofu Salad",
        price: 99,
        oldPrice: 16,
        discount: "15%",
        desc: "this is the description",
        reviews: [
            {
                name: "jhon doe",
                rating: 4.6,
            },
            {
                name: "jhon doe",
                rating: 5,
            },
        ],
        avgRating: 4.5,
        photo: foodImg2,
    },
    {
        id: "03",
        title: "Tomato With Tofu Salad",
        price: 99,
        oldPrice: 12,
        discount: "15%",
        desc: "this is the description",
        reviews: [
            
        ],
        avgRating: 4.5,
        photo: foodImg3,
    },
    {
        id: "04",
        title: "Tomato With Tofu Salad",
        price: 99,
        oldPrice: 15,
        discount: "15%",
        desc: "this is the description",
        reviews: [
            {
                name: "jhon doe",
                rating: 4.6,
            },
            {
                name: "jhon doe",
                rating: 5,
            },
        ],
        avgRating: 4.5,
        photo: foodImg4,
        featured: true,
    },
    {
        id: "05",
        title: "Tomato With Tofu Salad",
        price: 99,
        oldPrice: 8,
        discount: "15%",
        desc: "this is the description",
        reviews: [
            
        ],
        avgRating: 4.5,
        photo: foodImg5,
        featured: true,
    },
    {
        id: "06",
        title: "Tomato With Tofu Salad",
        price: 99,
        discount: "15%",
        oldPrice: 10,
        desc: "this is the description",
        reviews: [
            {
                name: "jhon doe",
                rating: 4.6,
            },
            {
                name: "jhon doe",
                rating: 5,
            },
        ],
        avgRating: 4.5,
        photo: foodImg6,
    },
    {
        id: "07",
        title: "Tomato With Tofu Salad",
        price: 99,
        discount: "15%",
        oldPrice: 10,
        desc: "this is the description",
        reviews: [
            {
                name: "jhon doe",
                rating: 4.6,
            },
            {
                name: "jhon doe",
                rating: 5,
            },
        ],
        avgRating: 4.5,
        photo: foodImg7,
    },
    {
        id: "08",
        title: "Tomato With Tofu Salad",
        price: 99,
        discount: "15%",
        oldPrice: 10,
        desc: "this is the description",
        reviews: [
            {
                name: "jhon doe",
                rating: 4.6,
            },
            {
                name: "jhon doe",
                rating: 5,
            },
        ],
        avgRating: 4.5,
        photo: foodImg8,
    },
    {
        id: "09",
        title: "Tomato With Tofu Salad",
        price: 99,
        discount: "15%",
        oldPrice: 10,
        desc: "this is the description",
        reviews: [
            {
                name: "jhon doe",
                rating: 4.6,
            },
            {
                name: "jhon doe",
                rating: 5,
            },
        ],
        avgRating: 4.5,
        photo: foodImg9,
    },
    {
        id: "10",
        title: "Tomato With Tofu Salad",
        price: 99,
        discount: "15%",
        oldPrice: 10,
        desc: "this is the description",
        reviews: [
            {
                name: "jhon doe",
                rating: 4.6,
            },
            {
                name: "jhon doe",
                rating: 5,
            },
        ],
        avgRating: 4.5,
        photo: foodImg10,
    }
   
];

export default foods;
